<template>
    <el-form :model="value" ref="formRef" label-position="top">
        <Panel title="连接池配置">
            <el-row>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="服务器IP地址" prop='host'>
                        <el-input v-model="value.host"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="监听端口" prop='port'>
                        <el-input v-model="value.port"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="队列管理器名称" prop='queueManager'>
                        <el-input v-model="value.queueManager"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="服务器连接通道名称" prop='channel'>
                        <el-input v-model="value.channel"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="双字节字符集标识" prop='ccsid'>
                        <el-input v-model="value.ccsid"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
        <Panel title="高级选项" collapse>
            <el-row>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="用户名" prop='username'>
                        <el-input v-model="value.username" placeholder="IBMMQ8.0以上版本需要填写服务器用户名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="密码" prop='password'>
                        <el-input v-model="value.password" placeholder="IBMMQ8.0以上版本需要填写服务器用户名"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
    </el-form>
</template>
<script>
export default {
    // host: "",
    // port: "",
    // username: "",
    // password: "",
    // queueManager: "",
    // channel: "",
    // ccsid: ""
    props: {
        value: Object
    },
    data() {
        return {
            rules: {
                host: [{required: true, trigger: "blur", message: "这是必填字段"}],
                port: [{required: true, trigger: "blur", message: "这是必填字段"}],
                queueManager: [{required: true, trigger: "blur", message: "这是必填字段"}],
                channel: [{required: true, trigger: "blur", message: "这是必填字段"}],
                ccsid: [{required: true, trigger: "blur", message: "这是必填字段"}]
            }
        };
    },
    methods: {
        validate() {
            return this.$refs.formRef.validate();
        }
    }

};
</script>

